// styles.js
export const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#EEF2F7',
    width: '100%',
    overflowX: 'hidden',
  },

  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '24px 16px',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
  },

  header: {
    backgroundColor: '#0B3A5B',
    borderRadius: 12,
    padding: '22px 18px',
    color: '#fff',
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
  },

  headerTop: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  },

  title: {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: 0.2,
  },

  subtitle: {
    marginTop: 6,
    fontSize: 13,
    opacity: 0.9,
  },

  headerBottom: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 14,
  },

  counterPill: {
    backgroundColor: 'rgba(255,255,255,0.14)',
    border: '1px solid rgba(255,255,255,0.22)',
    padding: '6px 10px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
  },

  progressTrack: {
    marginTop: 12,
    height: 8,
    borderRadius: 999,
    backgroundColor: 'rgba(255,255,255,0.20)',
    overflow: 'hidden',
  },

  progressFill: pct => ({
    width: `${Math.max(0, Math.min(100, pct || 0))}%`,
    height: '100%',
    borderRadius: 999,
    backgroundColor: '#22C55E',
  }),

  body: {
    marginTop: 16,
  },

  alertError: {
    backgroundColor: '#FEE2E2',
    border: '1px solid #FCA5A5',
    padding: 12,
    borderRadius: 10,
    marginBottom: 12,
  },

  alertSuccess: {
    backgroundColor: '#DCFCE7',
    border: '1px solid #86EFAC',
    padding: 12,
    borderRadius: 10,
    marginBottom: 12,
  },

  card: {
    backgroundColor: '#fff',
    borderRadius: 14,
    padding: 16,
    border: '1px solid #E5E7EB',
    boxShadow: '0 10px 30px rgba(17,24,39,0.06)',
  },

  formGrid: isMobile => ({
    marginTop: 14,
    display: 'grid',
    gap: 12,
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
  }),

  phoneRow: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },

  ddiField: {
    width: 90,
  },

  phoneField: {
    flex: 1,
    minWidth: 0,
  },

  formActions: isMobile => ({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
    gridColumn: isMobile ? 'span 1' : '1 / -1',
  }),

  grid: isMobile => ({
    display: 'grid',
    gap: 14,
    gridTemplateColumns: isMobile ? 'minmax(0, 1fr)' : 'repeat(2, minmax(0, 1fr))',
    alignItems: 'start',
    width: '100%',
    minWidth: 0,
  }),

  questionGroup: isMobile => ({
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: 12,
    padding: isMobile ? 10 : 14,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  }),

  subQuestionsGroup: {
    borderTop: '1px dashed #E5E7EB',
    paddingTop: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    background: '#F9FAFB',
    borderRadius: 8,
    padding: 10,
  },

  questionCard: ok => ({
    backgroundColor: '#fff',
    borderRadius: 14,
    padding: 16,
    border: ok ? '1px solid #86EFAC' : '1px solid #E5E7EB',
    boxShadow: '0 10px 30px rgba(17,24,39,0.06)',
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
    boxSizing: 'border-box',
  }),

  qTop: {
    display: 'flex',
    gap: 12,
    alignItems: 'flex-start',
    marginBottom: 12,
  },

  qNumber: {
    minWidth: 28,
    height: 28,
    borderRadius: 999,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F3F4F6',
    color: '#111827',
    fontSize: 12,
    fontWeight: 800,
  },

  qText: {
    fontSize: 14,
    fontWeight: 800,
    color: '#111827',
    lineHeight: 1.25,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },

  boolRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    width: '100%',
    minWidth: 0,
  },

  boolBtn: active => ({
    border: active ? '1px solid #1D4ED8' : '1px solid #D1D5DB',
    backgroundColor: active ? '#EFF6FF' : '#fff',
    color: active ? '#1D4ED8' : '#111827',
    borderRadius: 10,
    padding: '10px 12px',
    cursor: 'pointer',
    fontWeight: 800,
    fontSize: 13,
    lineHeight: 1.3,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    hyphens: 'auto',
  }),

  textarea: {
    width: '100%',
    maxWidth: '100%',
    minHeight: 120,
    resize: 'vertical',
    borderRadius: 12,
    padding: 12,
    border: '1px solid #D1D5DB',
    outline: 'none',
    fontSize: 16,
    boxSizing: 'border-box',
  },

  fileRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 10,
    backgroundColor: '#F9FAFB',
    border: '1px solid #E5E7EB',
    borderRadius: 12,
    padding: 10,
    width: '100%',
    boxSizing: 'border-box',
  },

  clearBtn: {
    border: 'none',
    backgroundColor: '#111827',
    color: '#fff',
    borderRadius: 10,
    padding: '8px 10px',
    cursor: 'pointer',
    fontWeight: 800,
    fontSize: 12,
  },

  footer: isMobile => ({
    position: 'sticky',
    bottom: 0,
    marginTop: 16,
    backgroundColor: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: 14,
    padding: 12,
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: isMobile ? 'stretch' : 'center',
    gap: isMobile ? 12 : 0,
    boxShadow: '0 10px 30px rgba(17,24,39,0.08)',
  }),

  leftFooter: isMobile => ({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    width: isMobile ? '100%' : 'auto',
    justifyContent: isMobile ? 'center' : 'flex-start',
  }),

  rightFooter: isMobile => ({
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 10,
    width: isMobile ? '100%' : 'auto',
  }),

  footerPrimaryButton: isMobile => ({
    width: isMobile ? '100%' : 'auto',
    minWidth: isMobile ? '100%' : 160,
  }),

  footerPrimaryContent: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },

  footerSecondaryButton: isMobile => ({
    width: isMobile ? '100%' : 'auto',
    minWidth: isMobile ? '100%' : 160,
  }),

  missing: {
    color: '#6B7280',
    fontSize: 13,
    fontWeight: 700,
  },

  topInner: isMobile => ({
    width: '100%',
    boxSizing: 'border-box',
    padding: isMobile ? '8px 12px 6px' : '10px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  }),

  logo: {
    width: 140,
    height: 'auto',
    userSelect: 'none',
  },

  headerArea: isMobile => ({
    width: '100%',
    boxSizing: 'border-box',
    padding: isMobile ? '10px 12px 12px' : '26px 24px 18px',
  }),

  headerRow: isMobile => ({
    display: 'flex',
    alignItems: isMobile ? 'flex-start' : 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexDirection: isMobile ? 'column' : 'row',
  }),

  headerTitle: {
    color: '#FFFFFF',
    fontWeight: 800,
    fontSize: 18,
    lineHeight: 1.2,
  },

  headerSub: {
    marginTop: 4,
    color: 'rgba(255,255,255,0.85)',
    fontWeight: 600,
    fontSize: 12,
  },

  counterPillTop: {
    alignSelf: 'flex-start',
    padding: '6px 10px',
    borderRadius: 999,
    backgroundColor: 'rgba(255,255,255,0.12)',
    color: '#FFFFFF',
    fontWeight: 800,
    fontSize: 12,
    whiteSpace: 'nowrap',
  },

  progressTrackTop: {
    marginTop: 10,
    height: 6,
    borderRadius: 999,
    backgroundColor: 'rgba(255,255,255,0.18)',
    overflow: 'hidden',
  },

  progressFillTop: pct => ({
    height: '100%',
    width: `${Math.max(0, Math.min(100, pct))}%`,
    backgroundColor: 'rgba(255,255,255,0.70)',
    borderRadius: 999,
  }),

  qDivider: {
    width: '100%',
    height: 1,
    backgroundColor: '#D1D5DB',
    marginTop: 10,
    marginBottom: 0,
  },

  messageWrap: () => ({
    width: '100%',
    marginBottom: 14,
  }),

  messageBox: (type = 'info') => {
    const base = {
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'center',
      padding: '10px 14px',
      borderRadius: 10,
      fontWeight: 700,
    };

    if (type === 'error')
      return { ...base, background: '#FEF2F2', border: '1px solid #FCA5A5' };
    if (type === 'success')
      return { ...base, background: '#ECFDF5', border: '1px solid #86EFAC' };
    if (type === 'warning')
      return { ...base, background: '#FFFBEB', border: '1px solid #F59E0B' };
    return { ...base, background: '#F3F4F6', border: '1px solid #E5E7EB' };
  },

  successContent: isMobile => ({
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
  }),

  certificateDownloadButton: (isMobile, disabled = false) => ({
    border: `1px solid ${disabled ? '#94A3B8' : '#059669'}`,
    backgroundColor: disabled ? '#94A3B8' : '#059669',
    color: '#FFFFFF',
    borderRadius: 8,
    padding: isMobile ? '10px 12px' : '8px 12px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: 13,
    fontWeight: 800,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    width: isMobile ? '100%' : 'auto',
    minHeight: 36,
    whiteSpace: 'nowrap',
    opacity: disabled ? 0.75 : 1,
  }),

  certificatePreviewCard: isMobile => ({
    backgroundColor: '#FFFFFF',
    border: '1px solid #D1FAE5',
    borderRadius: 12,
    boxShadow: '0 14px 40px rgba(17,24,39,0.08)',
    padding: isMobile ? 12 : 16,
  }),

  certificatePreviewHeader: isMobile => ({
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: isMobile ? 'stretch' : 'center',
    gap: 14
  }),

  certificatePreviewTitleWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
  },

  certificatePreviewTitle: {
    fontWeight: 800,
    marginBottom: 2,
  },

  certificatePreviewSubtitle: {
    fontSize: 13,
    lineHeight: 1.35,
  },

  certificatePreviewActions: isMobile => ({
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    gap: 10,
    alignItems: 'center',
    width: isMobile ? '100%' : 'auto',
  }),

  videoGateCard: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E7EB',
    borderRadius: 14,
    boxShadow: '0 10px 30px rgba(17,24,39,0.06)',
    padding: 0,
    overflow: 'hidden',
  },

  videoGateHeader: {
    padding: '14px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },

  videoGateHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
  },

  videoCounterText: {
    marginTop: 4,
    color: '#6B7280',
    fontSize: 13,
  },

  videoGateIconBox: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: '#EAF2FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  videoGateTitle: {
    fontSize: 16,
    lineHeight: 1.2,
    fontWeight: 800,
    color: '#111827',
  },

  videoGateSubtitle: {
    marginTop: 4,
    fontSize: 13,
    color: '#6B7280',
    lineHeight: 1.4,
  },

  videoGateDivider: {
    width: '100%',
    height: 1,
    backgroundColor: '#E5E7EB',
  },

  videoLabel: {
    padding: '16px 16px 10px',
    fontSize: 16,
    fontWeight: 800,
    color: '#111827',
  },

  videoPlayerWrap: {
    padding: '0 16px',
    boxSizing: 'border-box',
  },

  videoShell: (isFullscreen, isMobile) => ({
    width: '100%',
    height: isFullscreen ? '100dvh' : 'auto',
    minHeight: isFullscreen ? '100dvh' : 'auto',
    backgroundColor: '#000000',
    borderRadius: isFullscreen ? 0 : 8,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    touchAction: isFullscreen && isMobile ? 'manipulation' : 'auto',
  }),

  videoLoadingOverlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    pointerEvents: 'none',
  },

  videoLoadingBox: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 16px',
    borderRadius: 999,
    color: '#FFFFFF',
    backgroundColor: 'rgba(15, 23, 42, 0.8)',
    border: '1px solid rgba(255,255,255,0.14)',
    fontSize: 14,
    fontWeight: 800,
    backdropFilter: 'blur(8px)',
  },

  videoIdleOverlay: useFallbackCover => ({
    position: 'absolute',
    inset: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: useFallbackCover
      ? 'linear-gradient(160deg, #163B63 0%, #0F172A 55%, #08111D 100%)'
      : 'linear-gradient(180deg, rgba(11,58,91,0.28) 0%, rgba(15,23,42,0.58) 100%)',
    pointerEvents: 'auto',
    cursor: 'pointer',
  }),

  videoIdleBackdrop: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '22px 20px',
    background:
      'radial-gradient(circle at top right, rgba(96,165,250,0.24) 0%, rgba(96,165,250,0) 36%), radial-gradient(circle at bottom left, rgba(14,165,233,0.18) 0%, rgba(14,165,233,0) 34%)',
  },

  videoIdleBackdropBadge: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px 10px',
    borderRadius: 999,
    backgroundColor: 'rgba(255,255,255,0.12)',
    border: '1px solid rgba(255,255,255,0.14)',
    color: '#E0F2FE',
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0.3,
    textTransform: 'uppercase',
  },

  videoIdleBackdropText: {
    maxWidth: 280,
    fontSize: 14,
    lineHeight: 1.45,
    fontWeight: 600,
    color: 'rgba(255,255,255,0.86)',
  },

  videoIdleBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    color: '#FFFFFF',
    textAlign: 'center',
    padding: '16px 20px',
  },

  videoIdleTitle: {
    fontSize: 16,
    fontWeight: 800,
    lineHeight: 1.3,
  },

  videoIdleSubtitle: {
    fontSize: 13,
    fontWeight: 600,
    opacity: 0.92,
    lineHeight: 1.4,
  },

  videoPlayer: (isFullscreen, hideBeforePlay = false) => {
    return {
      width: isFullscreen ? '100%' : '100%',
      maxWidth: isFullscreen ? '100vw' : '100%',
      height: isFullscreen ? '100%' : 'auto',
      maxHeight: isFullscreen ? '100dvh' : 700,
      minHeight: isFullscreen ? 'auto' : 240,
      objectFit: 'contain',
      borderRadius: isFullscreen ? 0 : 8,
      border: isFullscreen ? 'none' : '1px solid #111827',
      backgroundColor: '#000000',
      display: 'block',
      margin: '0 auto',
      opacity: hideBeforePlay ? 0 : 1,
    };
  },

  videoControlsWrap: (isTop = false) => ({
    marginTop: isTop ? 0 : 12,
    marginBottom: isTop ? 12 : 0,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: 12,
    padding: '12px 14px',
    border: '1px solid #E5E7EB',
    borderRadius: 10,
    backgroundColor: '#F9FAFB',
  }),

  videoControlPrimary: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    border: 'none',
    borderRadius: 10,
    backgroundColor: '#0F2F4F',
    color: '#FFFFFF',
    padding: '10px 14px',
    fontSize: 14,
    fontWeight: 800,
    cursor: 'pointer',
  },

  videoPrimaryActions: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 10,
    flexWrap: 'wrap',
  },

  videoVolumeGroup: (dark = false, isMobile = false) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: isMobile ? '100%' : 168,
    color: dark ? '#FFFFFF' : '#111827',
  }),

  videoVolumeSlider: dark => ({
    width: 110,
    accentColor: dark ? '#60A5FA' : '#2563EB',
    cursor: 'pointer',
  }),

  videoControlSecondary: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    border: '1px solid #CBD5E1',
    borderRadius: 10,
    backgroundColor: '#FFFFFF',
    color: '#0F172A',
    padding: '10px 14px',
    fontSize: 14,
    fontWeight: 800,
    cursor: 'pointer',
  },

  videoControlSecondaryDark: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    border: '1px solid rgba(255,255,255,0.22)',
    borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0.12)',
    color: '#FFFFFF',
    padding: '10px 14px',
    fontSize: 14,
    fontWeight: 800,
    cursor: 'pointer',
    backdropFilter: 'blur(8px)',
  },

  videoSpeedWrap: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    gap: 4,
    minWidth: 200,
    flex: 1,
  },

  videoSpeedLabel: {
    fontSize: 11,
    fontWeight: 800,
    color: '#374151',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },

  videoSpeedOptions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
  },

  videoSpeedButton: active => ({
    border: active ? '1px solid #2563EB' : '1px solid #D1D5DB',
    borderRadius: 999,
    backgroundColor: active ? '#DBEAFE' : '#FFFFFF',
    color: active ? '#1D4ED8' : '#111827',
    minWidth: 42,
    height: 36,
    padding: '0 10px',
    fontSize: 12,
    fontWeight: 800,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  videoSpeedButtonDark: active => ({
    border: active ? '1px solid #60A5FA' : '1px solid rgba(255,255,255,0.24)',
    borderRadius: 999,
    backgroundColor: active
      ? 'rgba(96,165,250,0.22)'
      : 'rgba(255,255,255,0.08)',
    color: '#FFFFFF',
    minWidth: 42,
    height: 36,
    padding: '0 10px',
    fontSize: 12,
    fontWeight: 800,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(8px)',
  }),

  videoOverlayControls: isMobile => ({
    position: 'absolute',
    left: isMobile ? 12 : 20,
    right: isMobile ? 12 : 20,
    bottom: isMobile ? 12 : 20,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: 12,
    flexWrap: 'wrap',
    padding: '12px 14px',
    borderRadius: 14,
    background:
      'linear-gradient(180deg, rgba(15,23,42,0.2) 0%, rgba(15,23,42,0.72) 100%)',
    border: '1px solid rgba(255,255,255,0.12)',
    backdropFilter: 'blur(10px)',
  }),

  videoOverlayLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
  },

  videoOverlayRight: isMobile => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: isMobile ? 'flex-start' : 'flex-end',
    gap: 6,
    width: isMobile ? '100%' : 'auto',
  }),

  videoOverlaySpeedLabel: {
    fontSize: 11,
    fontWeight: 800,
    color: 'rgba(255,255,255,0.82)',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },

  videoMetaInfo: {
    minWidth: 160,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 4,
  },

  videoMetaLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: '#B45309',
  },

  videoMetaTime: {
    fontSize: 13,
    fontWeight: 800,
    color: '#111827',
  },

  videoUnavailable: {
    width: '100%',
    minHeight: 320,
    borderRadius: 8,
    border: '1px solid #E5E7EB',
    backgroundColor: '#F9FAFB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  videoInfoBox: {
    margin: '18px 16px 0',
    border: '1px solid #BFDBFE',
    backgroundColor: '#EFF6FF',
    borderRadius: 8,
    padding: '14px 16px',
  },

  videoInfoTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 15,
    fontWeight: 800,
    color: '#1D4ED8',
  },

  videoInfoText: {
    marginTop: 6,
    fontSize: 14,
    lineHeight: 1.45,
    color: '#1D4ED8',
  },

  videoProgressWrap: {
    margin: '18px 16px 0',
  },

  videoProgressRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 8,
  },

  videoProgressTitle: {
    fontSize: 14,
    fontWeight: 800,
    color: '#111827',
  },

  videoProgressValue: {
    fontSize: 13,
    fontWeight: 800,
    color: '#2563EB',
  },

  videoProgressTrack: {
    width: '100%',
    height: 10,
    borderRadius: 999,
    backgroundColor: '#DBEAFE',
    overflow: 'hidden',
  },

  videoProgressFill: pct => ({
    width: `${Math.max(0, Math.min(100, pct || 0))}%`,
    height: '100%',
    borderRadius: 999,
    background: 'linear-gradient(90deg, #2563EB 0%, #22C55E 100%)',
  }),

  videoContinueBtn: isMobile => ({
    justifyContent: 'center',
    flex: 1,
    minWidth: isMobile ? '100%' : 220,
    width: isMobile ? '100%' : 'auto',
  }),

  videoContinueContent: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    textAlign: 'center',
  },

  videoFooterActions: {
    width: 'calc(100% - 32px)',
    margin: '18px 16px 16px',
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
  },

  videoBackBtn: isMobile => ({
    justifyContent: 'center',
    minWidth: isMobile ? '100%' : 220,
    width: isMobile ? '100%' : 'auto',
  }),

  gridMaxWidth: (cols, isMobile) => {
    const minCard = 320;
    const gap = isMobile ? 12 : 16;
    if (cols === 1) return minCard;
    if (cols === 2) return minCard * 2 + gap;
    return minCard * 3 + gap * 2;
  },
};
